import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { RequireAuth } from "@/components/RequireAuth";
import { RequireOnboarded } from "@/components/RequireOnboarded";
import { Dashboard } from "@/pages/Dashboard";
import { Certificates } from "@/pages/Certificates";
import { CertificateDetail } from "@/pages/CertificateDetail";
import { CertificateRequestDetail } from "@/pages/CertificateRequestDetail";
import { Request } from "@/pages/Request";
import { Documents } from "@/pages/Documents";
import { Profile } from "@/pages/Profile";
import { Help } from "@/pages/Help";
import { Login } from "@/pages/Login";
import { AuthCallback } from "@/pages/AuthCallback";
import { PaymentReturn } from "@/pages/PaymentReturn";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route element={<RequireAuth />}>
        <Route path="pagar/retorno" element={<PaymentReturn />} />
        <Route path="pagar/:token" element={<PaymentReturn />} />
        <Route element={<RequireOnboarded />}>
          <Route element={<AppShell />}>
            <Route index element={<Dashboard />} />
            <Route path="certificados" element={<Certificates />} />
            <Route path="certificados/solicitudes/:id" element={<CertificateRequestDetail />} />
            <Route path="certificados/:id" element={<CertificateDetail />} />
            <Route path="solicitar" element={<Request />} />
            <Route path="documentos" element={<Documents />} />
            <Route path="perfil" element={<Profile />} />
            <Route path="ayuda" element={<Help />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}
